<template>
  <div class="centered-container">
    <div class="verification-box bg-white p-8 rounded">
      <!-- Initial state -->
      <div v-if="!verificationStarted">
        <!-- TODO ripristinare questo nelle prossime fasi
        <p class="text-center mb-6 text-lg">
          Benvenut*!<br>
          Ci siamo quasi: per garantire la sicurezza di tutt*,<br>
          abbiamo bisogno di verificare la tua identità.
        </p> -->
        <p class="text-center mb-6 text-lg" style="color:black">
          In questa fase, puoi registrarti solamente con la mail istituzionale @comprensivocentallo.edu.it o @iccervasca.edu.it.
          <button @click="logout" class="logout-btn">Logout</button>
        </p>
        <!-- TODO ripristinare <div id="veriff-root"></div> -->
      </div>

      <!-- Consent step -->
      <div v-else-if="verificationStarted && !consentGiven">
        <h2 class="text-xl font-semibold mb-6 text-center">Termini e Condizioni</h2>
        <div class="consent-container">
          <div class="checkbox-container mb-4">
            <input type="checkbox" id="consent-checkbox" v-model="isConsented">
            <label for="consent-checkbox" class="ml-2">Accetto i termini e le condizioni di utilizzo presenti nel documento sottostante</label>
          </div>
          <button
            @click="confirmConsent"
            :disabled="!isConsented"
            class="consent-btn mb-4"
            :class="{'consent-btn-disabled': !isConsented}"
          >
            Conferma
          </button>
          <div class="doc-container">
            <iframe src="https://docs.google.com/document/d/1wQFUgLAl4tRn99A5uHiH-bT837szl8i4/preview?usp=sharing&embedded=true" frameborder="0" allowfullscreen></iframe>
          </div>
        </div>
      </div>

      <!-- Role selection -->
      <div v-else-if="consentGiven && !roleSelected">
        <h2 class="text-xl font-semibold mb-6 text-center">Seleziona il tuo ruolo</h2>
        <div class="space-y-6" style="text-align:center;">
          <!-- TODO eventualmente ripristinare <div class="flex justify-center gap-4 mb-8">
            <button
                @click="selectRole('tutor')"
                :class="['role-btn', selectedRole === 'tutor' ? 'role-btn-active' : '']"
            >
              Tutor
            </button>
            <button
                @click="selectRole('student')"
                :class="['role-btn', selectedRole === 'student' ? 'role-btn-active' : '']"
            >
              Studente
            </button>
          </div>-->

          <!-- Buddy option for students -->
          <div v-if="selectedRole === 'student'" class="transition-all duration-300">
            <p class="mb-4 text-gray-700">Vuoi essere disponibile come tutor tra pari?</p>
            <div class="flex justify-center gap-4">
              <button
                  @click="setBuddy(true)"
                  :class="['buddy-btn', isBuddy === true ? 'buddy-btn-active' : '']"
              >
                Sì
              </button>
              <button
                  @click="setBuddy(false)"
                  :class="['buddy-btn', isBuddy === false ? 'buddy-btn-active' : '']"
              >
                No
              </button>
            </div>
          </div>

          <button
              @click="confirmRole"
              :disabled="!canConfirm"
              class="confirm-btn mt-8"
              :class="{'confirm-btn-disabled': !canConfirm}"
          >
            Conferma
          </button>
        </div>
      </div>

      <!-- Verification in progress -->
      <div v-else-if="roleSelected && !verificationCompleted">
        <div class="spinner mb-6"></div>
        <p class="text-lg mb-2 text-center">Stiamo verificando la tua identità...<br>
          Per favore, non chiudere questa finestra.</p>
        <p class="text-sm text-gray-600 mt-4 text-center">
          Questo processo potrebbe richiedere qualche minuto.
        </p>
      </div>

      <!-- Verification completed -->
      <div v-else-if="verificationCompleted && roleSelected">
        <div class="success-icon mb-6"></div>
        <p class="text-lg text-center">Verifica completata con successo!<br>
          Stai per essere reindirizzato...</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.centered-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
  color:black;
}

.verification-box {
  max-width: 800px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.spinner {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.success-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  background-color: #4CAF50;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  content: "✓";
}

.role-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
}

.role-btn-active {
  background-color: #3498db;
  color: white;
  border-color: #3498db;
  transform: scale(1.05);
}

.buddy-btn {
  padding: 8px 20px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
  background-color: #f8fafc;
  border: 2px solid #e2e8f0;
}

.buddy-btn-active {
  background-color: #4CAF50;
  color: white;
  border-color: #4CAF50;
}

.confirm-btn {
  padding: 12px 32px;
  border-radius: 8px;
  font-weight: 600;
  background-color: #3498db;
  color: white;
  transition: all 0.3s ease;
}

.confirm-btn:hover:not(.confirm-btn-disabled) {
  background-color: #2980b9;
  transform: translateY(-1px);
}

.confirm-btn-disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
}

.logout-btn {
  padding: 6px 12px;
  margin-left: 10px;
  border-radius: 4px;
  font-weight: 500;
  background-color: #e53e3e;
  color: white;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background-color: #c53030;
}

/* Consent step styles */
.consent-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.doc-container {
  width: 100%;
  max-width: 750px;
  height: 450px;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
}

.doc-container iframe {
  width: 100%;
  height: 100%;
  border: 1px solid #e2e8f0;
}

.checkbox-container {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}

.consent-btn {
  padding: 12px 32px;
  border-radius: 8px;
  font-weight: 600;
  background-color: #4CAF50;
  color: white;
  transition: all 0.3s ease;
}

.consent-btn:hover:not(.consent-btn-disabled) {
  background-color: #45a049;
  transform: translateY(-1px);
}

.consent-btn-disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<script>
import config from "@/utils/config";

export default {
  name: 'VeriffVerification',
  data() {
    return {
      verificationId: null,
      verificationStarted: false,
      verificationCompleted: false,
      errorOccurred: false,
      redirectUrl: null,
      userId: null,
      selectedRole: null,
      isBuddy: null,
      roleSelected: false,
      isConsented: false,
      consentGiven: false
    };
  },
  computed: {
    canConfirm() {
      if (this.selectedRole === 'tutor') return true;
      if (this.selectedRole === 'student') return this.isBuddy !== null;
      return false;
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.redirectUrl = urlParams.get('redirect') || 'virtual.smartscholars.it';
    this.userId = urlParams.get('verify');

    // Check if consent was previously given
    this.consentGiven = localStorage.getItem('consent_given') === 'true';

    if (this.userId) {
      this.checkVerificationStatus();
    } else {
      this.loadVeriff();
    }
    this.selectRole('student'); // TODO rimuovere se si ripristina la scelta
  },
  methods: {
    confirmConsent() {
      if (this.isConsented) {
        localStorage.setItem('consent_given', 'true');
        this.consentGiven = true;
      }
    },
    logout() {
      // Clear localStorage
      localStorage.clear();

      // Clear sessionStorage
      sessionStorage.clear();

      // Clear cookies from current domain and all subdomains
      this.clearAllCookies();

      // Redirect to login page or home page
      window.location.href = 'https://virtual.smartscholars.it/';
    },
    clearAllCookies() {
      // Get the domain parts
      const domain = window.location.hostname;
      const domainParts = domain.split('.');

      // Get all cookies
      const cookies = document.cookie.split(';');

      // For each cookie, attempt to delete it at various domain levels
      cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();

        // Delete from current domain
        this.deleteCookie(cookieName, '');

        // Delete from root domain (no subdomain specification)
        this.deleteCookie(cookieName, `.${domainParts.slice(-2).join('.')}`);

        // If we have subdomains, handle them too
        if (domainParts.length > 2) {
          // Delete from current subdomain
          this.deleteCookie(cookieName, domain);

          // Try deleting from various subdomain levels
          for (let i = 0; i < domainParts.length - 1; i++) {
            const subDomain = `.${domainParts.slice(i).join('.')}`;
            this.deleteCookie(cookieName, subDomain);
          }
        }
      });
    },
    deleteCookie(name, domain) {
      // Set expiration to the past
      const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';

      // Create path and domain strings
      const path = 'path=/';
      const domainStr = domain ? `domain=${domain}` : '';

      // Combine cookie attributes
      const cookieString = domainStr
        ? `${name}=; ${expires}; ${path}; ${domainStr}`
        : `${name}=; ${expires}; ${path}`;

      // Set the expired cookie
      document.cookie = cookieString;
    },
    selectRole(role) {
      this.selectedRole = role;
      if (role === 'tutor') {
        this.isBuddy = null;
      }
    },
    setBuddy(value) {
      this.isBuddy = value;
    },
    async confirmRole() {
      if (!this.canConfirm) return;

      try {
        const params = new URLSearchParams();
        params.append('role', this.selectedRole);
        if (this.selectedRole === 'student') {
          params.append('isBuddy', this.isBuddy.toString());
        }

        await fetch(`${config.baseUrl}/user/setRole/${this.userId}?${params.toString()}`, {
          method: 'POST'
        });

        this.roleSelected = true;

        if (this.verificationCompleted) {
          this.redirect();
        }
      } catch (error) {
        console.error('Error setting role:', error);
      }
    },
    checkVerificationStatus() {
      fetch(`${config.baseUrl}/user/isVerified/${this.userId}`)
          .then(response => response.json())
          .then(isVerified => {
            if (isVerified) {
              this.verificationCompleted = true;
              this.verificationStarted = true;
            } else {
              this.loadVeriff();
            }
          })
          .catch(error => {
            console.error('Error checking verification status:', error);
            this.loadVeriff();
          });
    },
    loadVeriff() {
      this.loadScripts().then(() => {
        this.initVeriff();
      });
    },
    loadScripts() {
      return Promise.all([
        this.loadScript('https://cdn.veriff.me/sdk/js/1.5/veriff.min.js'),
        this.loadScript('https://cdn.veriff.me/incontext/js/v1/veriff.js'),
      ]);
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    initVeriff() {
      fetch(config.baseUrl + '/api/veriff/session')
          .then(response => response.json())
          .then(data => {
            // eslint-disable-next-line no-undef
            const veriff = Veriff({
              host: 'https://stationapi.veriff.com',
              apiKey: data.apiKey,
              parentId: 'veriff-root',
              onSession: (err, response) => {
                this.verificationId = response.verification.id;
                this.verificationStarted = true;
                window.veriffSDK.createVeriffFrame({
                  url: response.verification.url,
                  onClose: () => {
                    console.log('Veriff frame closed, waiting for verification...');
                  }
                });
                this.listenForVerificationResult();
              }
            });
            veriff.setParams({
              person: {
                givenName: ' ',
                lastName: ' '
              },
              vendorData: this.userId
            });
            veriff.mount();
          });
    },
    listenForVerificationResult() {
      const eventSource = new EventSource(config.baseUrl + `/api/veriff/status/${this.verificationId}`);

      eventSource.onmessage = (event) => {
        const data = JSON.parse(event.data);
        console.log('Received SSE message:', data);

        if (data === 'Connected') {
          console.log('SSE connection established');
          return;
        }

        if (data.status === 'approved') {
          this.verificationCompleted = true;
          eventSource.close();

          if (this.roleSelected) {
            setTimeout(this.redirect, 2000);
          }
        }
      };

      eventSource.onerror = (error) => {
        console.error('EventSource failed:', error);
        if (!this.verificationCompleted) {
          setTimeout(() => {
            console.log('Attempting to reconnect...');
            this.listenForVerificationResult();
          }, 5000);
        }
      };
    },
    redirect() {
      const url = this.redirectUrl.startsWith('http')
          ? this.redirectUrl
          : `https://${this.redirectUrl}`;
      window.location.href = url;
    }
  }
};
</script>